/**
 * Where the address of the API comes from.
 *
 * Never a literal in application code (.claude/rules/conventions.md): the API
 * address is deployment configuration and differs per environment. On the
 * server side it is `COUNTDOWN_API_BASE_URL`, the variable the compose service
 * definition already sets for the participant frontend
 * (ops/compose/countdown.yaml).
 *
 * There is deliberately no default value. A fallback like "http://localhost"
 * would turn a missing variable into a container that starts, answers, and
 * quietly talks to nothing.
 */
/** Name of the environment variable that carries the API base URL. */
export const API_BASE_URL_ENV_VAR = 'COUNTDOWN_API_BASE_URL';
/**
 * Strips a trailing slash so that the generated paths ("/api/v1/...") never
 * produce a double slash. Everything else is passed through unchanged: the
 * client is not the place to invent or repair addresses.
 */
export function normalizeBaseUrl(baseUrl) {
    const trimmed = baseUrl.trim();
    if (trimmed === '') {
        throw new Error('The API base URL is empty.');
    }
    return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
}
/**
 * Reads the base URL out of an environment-like record.
 *
 * The record is passed in rather than read from a global, so this works the
 * same in a Node process (`process.env`), in an Astro server island
 * (`import.meta.env`) and in a test, and stays testable without a live run.
 */
export function readApiBaseUrl(env) {
    const configured = env[API_BASE_URL_ENV_VAR];
    if (configured === undefined || configured.trim() === '') {
        throw new Error(`${API_BASE_URL_ENV_VAR} is not set. The API address is deployment configuration, not a default.`);
    }
    return normalizeBaseUrl(configured);
}
//# sourceMappingURL=config.js.map